import React, { FC } from "react";
import { useNavigate } from "react-router-dom";

// componet
import { OrderList } from "./List/OrderList";
import { LoadingComponent } from "../../../components/common/Loading";
import { ErrorComponent } from "../../../components/common/ErrorComponent";

interface RecentOrderProps {
  data: any[];
  loading: boolean;
  error: string;
}

export const RecentOrder: FC<RecentOrderProps> = ({ data, loading, error }) => {
  const navigate = useNavigate();

  const handleListClick = (id: number) => {
    navigate(`/customer/order/invoice-order/${id}`);
  };

  if (loading) {
    return <LoadingComponent />;
  }

  if (error) {
    return <ErrorComponent message={error} />;
  }

  return (
    <ul style={{ listStyle: "none" }} className="mt-5 p-0">
      {data.map((item: any) => (
        <OrderList
          key={item?.id}
          onClick={() => handleListClick(item?.id)}
          customerName={item?.customerDetails?.name}
          time={item?.created_at}
          price={item?.total_price}
        />
      ))}
    </ul>
  );
};
